import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance3ftsl9x5arf2y as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instanceqqdki6i32scv as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance1r5xzfn2s7bx0 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Input type used in output position');
      }
      toJson_22iyvh_k$(writer, customScalarAdapters, value) {
        writer.name_i73qwh_k$('id');
        get_playerIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.id_1);
        writer.name_i73qwh_k$('name');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.name_1);
        writer.name_i73qwh_k$('email');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.email_1);
        var tmp = value.badge_1;
        if (tmp instanceof Present()) {
          writer.name_i73qwh_k$('badge');
          present(nullable(Badge_ResponseAdapter_instance)).toJson_fhp2jo_k$(writer, customScalarAdapters, value.badge_1);
        }
        writer.name_i73qwh_k$('callSignAdjective');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.callSignAdjective_1);
        writer.name_i73qwh_k$('callSignNoun');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.callSignNoun_1);
        var tmp_0 = value.imageURL_1;
        if (tmp_0 instanceof Present()) {
          writer.name_i73qwh_k$('imageURL');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.imageURL_1);
        }
        var tmp_1 = value.avatarType_1;
        if (tmp_1 instanceof Present()) {
          writer.name_i73qwh_k$('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).toJson_fhp2jo_k$(writer, customScalarAdapters, value.avatarType_1);
        }
        writer.name_i73qwh_k$('unvalidatedEmails');
        list(get_StringAdapter()).toJson_t3q33c_k$(writer, customScalarAdapters, value.unvalidatedEmails_1);
        writer.name_i73qwh_k$('pins');
        list(obj(PinInput_InputAdapter_instance)).toJson_t3q33c_k$(writer, customScalarAdapters, value.pins_1);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_22iyvh_k$(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instance25ndfd53w8tvw,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
